document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('bb-popup');

  if (!popup) return;

  const closeButton = popup.querySelector('.bb-popup__close');

  function openPopup() {
    popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  closeButton.addEventListener('click', closePopup);

  popup.addEventListener('click', function (event) {
    if (event.target === popup) {
      closePopup();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePopup();
    }
  });

  setTimeout(openPopup, 1000);
});